import { catalog } from './catalog.js';
import { settings, storage } from './storage.js';
import { pickVariant } from './variants.js';

/* Qué versión de un canal se abre en una vista previa. Los canales suelen venir en varias calidades (SD / HD / FHD) y la ligera
   arranca antes y gasta menos: en la ventanita pequeña va siempre la más ligera; en la vista «En pantalla» se elige como en el
   reproductor (según el ajuste de calidad y la velocidad de la conexión que se midió la última vez). */

const estimateKbps = () => {
    const saved = storage.get('netKbps');
    return saved && Date.now() - (saved.at || 0) < 10 * 60000 ? Number(saved.kbps) || 0 : 0;
};

export function previewChannel(ch, { big = false } = {}) {
    if (!ch) return ch;
    let variants = [];
    try { variants = catalog.channelVariants(ch.id); } catch (e) { variants = []; }
    if (variants.length < 2) return ch;
    const mode = big ? (settings.get('liveQuality') || 'auto') : 'saver';
    return pickVariant({ variants, current: ch, estimateKbps: big ? estimateKbps() : 0, mode }) || ch;
}
